import {useHistory, Link} from "react-router-dom"

const IdMeModal = (props) => {
    const history = useHistory();
    const {handleSkip, credentials} = props;

    const url = `https://api.id.me/oauth/authorize?client_id=${credentials.client_id}&redirect_uri=${credentials.redirect_uri}&response_type=code&scope=military&code_challenge=${localStorage.getItem("codeChallenge")}&code_challenge_method=${localStorage.getItem("code_challenge_method")}`
  return (
    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-sm">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 text-center">
                <div className="px-1 sm:px-4 mt-4 sm:mt-3 text-center">
                    <h3 className="text-xl md:text-2xl font-medium text-darkGreen" id="modal-title">Get Verify With</h3>
                    {/* <img   src="./images/Audio-cross.svg"/> */}
                    <div className="mt-6 flex justify-center">
                      <img src="/images/verify-logo.svg" alt="" className='max-w-full h-auto text-center'/>
                    </div>
                </div>
                <div className="px-1 sm:px-4 py-3 flex mt-0 sm:mt-2">
                  <a href={url} className="focus:outline-none font-medium w-9/12 text-sm mx-auto transform rounded-full bg-darkGreen px-1 py-3 font-jakartaMedium tracking-wide text-darkGreen-200 transition-colors duration-200 hover:bg-darkGreen focus:bg-darkGreen disabled:cursor-default disabled:opacity-50 text-white mt-3">Verify</a>
                </div>
                <span onClick={handleSkip} className="text-base text-middleGreen h-5 w-5 underline cursor-pointer mb-2">skip</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default IdMeModal;